import { NgClass, NgTemplateOutlet } from '@angular/common';
import { 
  Component, ChangeDetectionStrategy, Input, QueryList, 
  ContentChildren, AfterContentInit, ViewChild, TemplateRef,
} from '@angular/core';

/**
 * interfaces
 */
import { ICardImage } from './interfaces/card-image';
import { ITemplateRef } from '@sharedDirectives/templates/interfaces/template';

/**
 * directives
*/
import { TemplateDirective } from '@sharedDirectives/templates/template.directive';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  host: { 
    '[class.card]': 'true',
    '[class]': 'ClassStyle'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    NgTemplateOutlet
  ],
})
export class CardComponent implements AfterContentInit {

  //---------------------- Decorators ----------------------//

  /**
   * @description to customize templates
   */
  @ContentChildren(TemplateDirective) public TemplatesDirectiveRef!: QueryList<TemplateDirective>

  /**
   * @description get cardBody templateRef
   */
  @ViewChild('cardBody', { static: true, read: TemplateRef }) private cardBodyTpl!: TemplateRef<any>;

  /**
   * @description get imageBlock templateRef
   */
  @ViewChild('imageBlock', { static: true, read: TemplateRef }) private imageBlockTpl!: TemplateRef<any>;

  /**
   * @description
   */
  @Input({ alias: 'image'})
  public Image!: ICardImage

  /**
   * @input Card header title.
   */
  @Input({ alias: 'title' })
  public title!: string;

  /**
   * @description css class
   */
  @Input({ alias: 'classStyle' })
  public ClassStyle!: string

  /**
   * @description css class
   */
  @Input({ alias: 'bodyClassStyle' })
  public BodyClassStyle: string = ''

  //---------------------- Fields ----------------------//

  /**
   * 
   */
  public HeaderTemplate!: ITemplateRef<any> | null

  /**
   * 
   */
  public BodyTemplate!: ITemplateRef<any> | null

  /**
   * 
   */
  public ImageTemplate!: ITemplateRef<ICardImage> | null  

  /**
   * 
   */
  public FooterTemplate!: ITemplateRef<any> | null  

  //---------------------- Accessors ----------------------//

  /** Determines if the image should be rendered after the body */
  public get IsImagePositionBottom(): boolean {
    return (this.Image?.position || this.ImageTemplate?.tempContext?.position) == 'bottom'
  }


  /** Returns the first block to render in the card layout */
  public get topSection(): TemplateRef<any> {
    return this.IsImagePositionBottom ? this.cardBodyTpl : this.imageBlockTpl;
  }

  /** Returns the second block to render in the card layout */
  public get bottomSection(): TemplateRef<any> {
    return this.IsImagePositionBottom ? this.imageBlockTpl : this.cardBodyTpl;
  }

  

  //---------------------- Methods ----------------------//
  
  ngAfterContentInit(): void {


    // TemplatesDirectiveRef
    if (this.TemplatesDirectiveRef != null && this.TemplatesDirectiveRef.length > 0) {

      // HeaderTemplate
      this.HeaderTemplate = TemplateDirective.findDirective<any>(this.TemplatesDirectiveRef, 'headerTemplate');

      // BodyTemplate
      this.BodyTemplate = TemplateDirective.findDirective<any>(this.TemplatesDirectiveRef, 'bodyTemplate');

      // ImageTemplate
      this.ImageTemplate = TemplateDirective.findDirective<ICardImage>(this.TemplatesDirectiveRef, 'imageTemplate');

      // FooterTemplate
      this.FooterTemplate = TemplateDirective.findDirective<any>(this.TemplatesDirectiveRef, 'footerTemplate');


    }


  }

}
